import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Navbar from "./components/Navbar";



export default function AddCompany() {
  const [formData, setFormData] = useState({
    ReviewByData: {
    SCORECARDDETAILS: "",
    SCORINGPERFORMEDBY: "",
    DATE: "",
    REVIEWEDBY: "",
    DATE_REVIEW: ""
  },
    NATUREOFBUSINESS: "",
    COMPANYTYPE: "",
    COMPANYINFO: {
      COMPANYNAME_ENGLISH: "",
      COMPANYNAME_CHINESE: "",
      PLACEOFINCORPORATION: "Hong Kong",
      BUSINESSREGISTRATIONNUMBER: "",
      UEN: "",
      REGISTEREDADDRESS: "",
      YEARFOUNDED: "",
      INDUSTRY: "",
    },
    BUSINESSADDRESS: {
    SAMEASREGISTERED: "",
    REGISTEREDBUSINESSADDRESS: ""
  },
    INDUSTRY: { CATEGORY: "", SUBCATEGORY: "" },
    STATUS: "",
    OWNERSHIPSTRUCTURE: {
      SHAREHOLDERCAPITALVALUE_HKD: "",
      PERIOD: "",
    },
    SHAREHOLDERS: [
  { NAME: "", OWNERSHIPPERCENTAGE: "" },
  { NAME: "", OWNERSHIPPERCENTAGE: "" },
  { NAME: "", OWNERSHIPPERCENTAGE: "" },
],
DIRECTORS: [
  { NAME: "" },
  { NAME: "" },
  { NAME: "" },
],

    PRIMARYCONTACT: {
  NAME: "",
  PHONENUMBER: [
    { code: "", number: "" },
    { code: "", number: "" },
  ],
  CONTACTEMAILADDRESS: "",
  RIVERCHAINRELATIONSHIPMANAGER: "",
},
    SECONDARYCONTACT: {
      NAME: "",
    PHONENUMBER: [
      { code: "", number: "" },
      { code: "", number: "" },
    ],
    CONTACTEMAILADDRESS: "",
    },
    PRIMARYACCOUNT: {
      beneficiaryName: "",
      bankAccountNumber: "",
      bankName: "",
      bankCode: "",
      swiftCode: "",
      Confirmation: "",
      accountInstructionDate: "",
    },
    ADDITIONALACCOUNTS: [],
    DOCUMENTSCHECKLIST: {
    SUBMITTEDBUSINESSREGISTRATION: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: true
    },
    COMPANYNAMEISCORRECT: {
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: true
    },
    THEREGISTRATIONISCURRENT: {
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: true
    },
    ENTEREXPIRYDATE: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SUBMITTEDANNUALRETURN_NAR1: {
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    THERETURNCOVERSTHEMOSTRECENTPERIOD: {
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SHAREHOLDER_SMATCHORGANIZATIONCHART_IFPROVIDED: {
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SUBMITTEDCERTIFICATEOFINCORPORATION: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SUBMITTEDMEMORANDUMANDARTICLES: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SUBMITTEDORGANIZATIONCHART_IFAPPLICABLE: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    THECHARTISSIGNEDANDDATED: {
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SUBMITTEDFINANCIALSTATEMENTS_AUDITEDFORTHELAST3YEARS: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: true
    },
    STATEMENTSARESIGNEDBYAUDITOR: {
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: true
    },
    SUBMITTEDUNAUDITEDMANAGEMENTACCOUNTSFORTHEMOSTRECENTPERIOD: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SUBMITTEDBANKACCOUNTINFORMATION: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SUBMITTEDALLBANKACCOUNTSTATEMENTSFORTHELAST3MONTHS_REQUIREDFORLOANS: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    },
    SUBMITTEDEVIDENCEOFSIGNATORYAUTHORISATION_INCASESIGNATORYISNOTADIRECTOROFTHECOMPANY: {
      CHECKINGDETAILS: "",
      STATU: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: true
    },
    SUBMITTEDLISTOFONGOINGTRADEDISPUTESANDLITIGATIONWITHANEXPLANATIONFOREACH_IFAPPLICABLE: {
      CHECKINGDETAILS: "",
      STATUS: "",
      COMMENTS: "",
      REVIEWERCHECK: "",
      ISMENDATORY: false
    }
  },
    FINANCIALANALYSIS: {
    FinDetails: {
      ENTERFINANCIALYEAREND: "",
      ENTERCURRENCY: "",
      UNIT: null
    },
    Auditor_Option: {
      AUDITOROPINION: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null,
      },
      ENTERAUDITOROPINION: {
        2021: "2021 \nAudited",
        2022: "2022 \nAudited",
        2023: "2023 \nAudited",
        2024: "2024 \nAudited",
        2025: "1Q 2025 \nUnaudited"
      }
    },
    INCOMESTATEMENT: {
      REVENUE: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      LESSCOSTOFSALES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      GROSSPROFIT: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      SGANDAEXPENSES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      EXTERNALOPERATINGCOSTS_INCLDISTRIBUTIONRANDDSERVICES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      TAXESOTHERTHANINCOMETAX: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      EBITDA: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DANDA: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      PROVISIONSANDIMPAIRMENTLOSSES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DISPOSALSOFPPE_GAINSORLOSSES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DISPOSALSOFINTANGIBLESSUBSIDIARIESANDAFFILIATES_GAINSORLOSSES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      GAINSOR_LOSSESRELATEDTOECLCREDITMODEL: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OTHERNON_RECURRINGINCOMEOREXPENSES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      FINANCECOSTS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      PROFITOR_LOSSBEFORETAX: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      INCOMETAXEXPENSE: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      PROFITOR_LOSSFORTHEYEAR: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      }
    },
    BALANCESHEET: {
      BALANCESHEET: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      NON_CURRENTASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      PROPERTYPLANTANDEQUIPMENT: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      RIGHT_OF_USEASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      INVESTMENTPROPERTIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      INVESTMENTSOREQUITYAFFILIATES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OTHERNON_CURRENTASSETS_INCLPROVISIONSETC: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      TOTALNON_CURRENTASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CURRENTASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      TRADERECEIVABLES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      RETENTIONRECEIVABLES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      GROSSAMOUNTSDUEFROMCUSTOMERFORCONTRACTWORKS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      INVENTORIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DEPOSITSPREPAYMENTSANDOTHERRECEIVABLES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DUEFROMDIRECTORS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DUEFROMRELATEDCOMPANIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DUEFROMSHAREHOLDERS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      INVESTMENTINQUOTEDSHARES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHANDBANKBALANCES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OTHERCURRENTASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CURRENTTAXRECOVERABLE: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      TOTALCURRENTASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      }
    },
    CURRENTLIABILITIES: {
      TRADEPAYABLES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      GROSSAMOUNTSDUETOCUSTOMERSFORCONTRACTWORKS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OTHERPAYABLESANDACCRUALS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DUETODIRECTORS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DUETORELATEDCOMPANIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DUETOSHAREHOLDERS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OBLIGATIONUNDERFINANCELEASES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      BANKOVERDRAFT: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      BANKBORROWINGS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OTHERCURRENTLIABILITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CURRENTTAXLIABILITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      TOTALCURRENTLIABILITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      NETCURRENTASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      }
    },
    NONCURRENTLIABILITIES: {
      OBLIGATIONUNDERFINANCELEASES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      BANKBORROWINGS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OTHERNON_CURRENTLIABILITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      TOTALNONCURRENTLIABILITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      NETASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      }
    },
    EQUITY: {
      SHARECAPITAL: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      ACCUMULATEDPROFITS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      TOTALSHAREHOLDERSEQUITY: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CHECK_SHOULDEQUALZERO: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      }
    },
    CASHFLOWSTATEMENT: {
      PROFITOR_LOSSFORTHEYEAR: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      ADJUSTMENTSFORNON_CASHITEMS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DANDA: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      FINANCECOSTS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      _ORGAINSOR_LOSSESONIMPAIRMENTORDISPOSALOFPROPERTYPLANTANDEQUIPMENT: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      _ORGAINSOR_LOSSESONREVALUATIONORDISPOSALOFINVESTMENTS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      _ORGAINSOR_LOSSESONEXCHANGEDIFFERENCE: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHFLOWBEFORECHANGESINWCRFFO: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      ADJUSTMENTSFORCHANGESINWORKINGCAPITAL: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OR_CHANGESINAR: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      OR_CHANGESISAP: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHFLOWFROMOPERATINGACTIVITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      _PURCHASESORDISPOSALSOFPROPERTYPLANTANDEQUIPMENT: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      _PURCHASESORDISPOSALSOFINVESTMENTS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      _PURCHASESORDISPOSALSOFRIGHT_OF_USEASSETS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHFLOWFROMINVESTINGACTIVITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CHANGESINAMOUNTSDUEORFROMDIRECTORSANDRELATEDPARTIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DRAWDOWNSOR_REPAYMENTSOFBORROWINGS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      INTERESTPAID: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CHANGESINCONTRIBUTEDCAPITAL: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      PAYMENTSOFDIVIDENDS: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHFLOWFROMFINANCINGACTIVITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHFLOWFORTHEYEAR: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CHANGEINCASHBALANCES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      }
    },
    RATIOS: {
      REVENUECHANGEPERCENTAGE: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CAGRPERCENTAGE: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      GROSSPROFITMARGIN: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      AVERAGEGROSSPROFITMARGIN: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      EBITDAMARGIN: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      NETPROFITMARGIN: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      LIQUIDITY: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CURRENTRATIO: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      QUICKRATIO: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CURRENTASSETSFROMRELATEDPARTIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHFLOWFROMOPERATINGACTIVITIES: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      LEVERAGE: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DEBTOREQUITYRATIO: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      NETDEBTOREBITDARATIO: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DEBTORASSETSRATIO: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      INTERESTCOVERAGERATIO: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHCONVERSION: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DAYSINVENTORYOUTSTANDING: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DAYSSALESOUTSTANDING: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DAYSPAYABLEOUTSTANDING: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      CASHCONVERSIONCYCLE: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      ENTERAUDITOROPINION: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      AUDITOROPINION: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      },
      DETAILS_IFAUDITOROPINIONISQUALIFIEDORNOTPROVIDED: {
        2021: null,
        2022: null,
        2023: null,
        2024: null,
        2025: null
      }
    }
  },
    WINDINGUP_LITIGATION_CHECKS: [
    {
      Criteria: "",
      CheckingDetails: "",
      NA: "",
      COMMENTS: "",
      RedFlag: "",
      ReviewerCheck: "",
      EntreDate: ""
    },
    {
      Criteria: "",
      CheckingDetails: "",
      NA: "",
      COMMENTS: "",
      RedFlag: "",
      ReviewerCheck: "",
      EntreDate: ""
    },
    {
      Criteria: "",
      CheckingDetails: "",
      NA: "",
      COMMENTS: "",
      RedFlag: "",
      ReviewerCheck: "",
      EntreDate: ""
    }
  ],
    ChargesRegister: [
    {
      Criteria: "",
      CheckingDetails: "",
      NA: "",
      COMMENTS: "",
      RedFlag: "",
      ReviewerCheck: "",
      EntreDate: ""
    }
  ],
    COMPANYSCORE: {
    BusinessScore: [
      {
        METRIC: "Country Risk",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Industry Risk",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Years in Operation",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Industry Reputation / Project Track Record",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Customer / Project Concentration",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Winding-up Petitions",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Material Litigation",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Ownership",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Management Ability",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Administrative Capacity",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Repayment Track Record of Riverchain's loans",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      }
    ],
    FinancialScore: [
      {
        METRIC: "Revenue (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Revenue Growth (2-Year CAGR)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Gross Profit (3-Year Average)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Liquidity Current Ratio (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Liquidity - Quick Ratio (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Liquidity - Cash Conversion Cycle (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Cashflow from Operating Activities (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Quality of Assets (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Solvency - Debt to Assets Ratio (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Solvency - Net Leverage Ratio (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Interest Coverage (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Qualified Opinion from Auditor (latest financial year)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      },
      {
        METRIC: "Known Defaults (last two years)",
        INPUT: null,
        SCORE: null,
        COMMENTS: "",
        REVIEWERCHECK: ""
      }
    ],
    QUALITYOFASSETS_LATESTFINANCIALYEAR: null,
    SOLVENCY_DEBTTOASSETSRATIO_LATESTFINANCIALYEAR: null,
    SOLVENCY_NETLEVERAGERATIO_LATESTFINANCIALYEAR: null,
    INTERESTCOVERAGE_LATESTFINANCIALYEAR: null,
    QUALIFIEDOPINIONFROMAUDITOR_LATESTFINANCIALYEAR: null
  },
    DEBTORRISKASSESSMENT: [
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    },
    {
      Criteria: "",
      INPUT: null,
      SCORE: null,
      Comments: "",
      ReviewerCheck: ""
    }
  ],
    DOCUMENTUPLOADED: {
    BR_FILES: [
      {
        FILE_NAME: "",
        LOCATION: "",
        VERSION: ""
      }
    ],
    NAR1_FILES: [
      {
        FILE_NAME: "",
        LOCATION: "",
        VERSION: ""
      }
    ],
    BANKSTMTS_FILES: [
      {
        FILE_NAME: "",
        LOCATION: "",
        VERSION: ""
      }
    ],
    FIN_FILES: [
      {
        FILE_NAME: "",
        LOCATION: "",
        VERSION: ""
      }
    ]
  },
  });
  const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
  const countryPhoneCodes = {
  "Hong Kong": "+852",
  "Singapore": "+65",
  "India": "+91",
  "China": "+86",
  "United States": "+1",
  "United Kingdom": "+44",
  "Australia": "+61",
  "Canada": "+1",
};
  const reviewedby = [
  "Kiril Popov",
  "Swati Jaiswal",
  "Shermaine Tan"
];

  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

const [banks, setBanks] = useState({});

useEffect(() => {
  axios
    .get("http://localhost:8000/riverchain/techop/v1.1/getBankcodes")
    .then((res) => {
      console.log("Bank API response:", res.data);

      const bankMap = {};
      res.data.forEach((bank) => {
        const name = bank["Bank Name"];
        const code = bank["Bank Code"];
        const swift = bank["Swift Code"];

        if (name) {
          bankMap[name] = {
            bankCode: code || "",
            swiftCode: swift || "",
          };
        }
      });

      setBanks(bankMap);
    })
    .catch((err) => console.error("Error fetching banks:", err));
}, []);



  const handleChange = (path, value) => {
  setFormData((prev) => {
    const updated = JSON.parse(JSON.stringify(prev || {}));
    const keys = path.replace(/\]/g, "").split(/\.|\[/);

    let cur = updated;
    for (let i = 0; i < keys.length - 1; i++) {
      const k = /^\d+$/.test(keys[i]) ? Number(keys[i]) : keys[i];
      const nextKey = keys[i + 1];
      const nextIsIndex = /^\d+$/.test(nextKey);

      if (cur[k] === undefined) {
        cur[k] = nextIsIndex ? [] : {};
      }
      cur = cur[k];
    }

    const last = /^\d+$/.test(keys[keys.length - 1])
      ? Number(keys[keys.length - 1])
      : keys[keys.length - 1];

    cur[last] = value;

    return updated;
  });
};

  const handleSubmit = async () => {
  setIsSubmitting(true);
  try {
    // ✅ Validation
    if (!formData?.COMPANYINFO?.COMPANYNAME_ENGLISH?.trim()) {
      toast.error("Company Name (English) is required");
      setIsSubmitting(false);
      return;
    }
    if (!formData?.COMPANYINFO?.COMPANYNAME_CHINESE?.trim()) {
      toast.error("Company Name (Chinese) is required");
      setIsSubmitting(false);
      return;
    }
    const payload = {
      VersionString: "Version 4.0 | 18 September 2025",
      RETURNSTATUS: "OK",
      ...formData,
      BUSINESSADDRESS: {
        SAMEASREGISTERED: true,
        REGISTEREDBUSINESSADDRESS:
          formData?.COMPANYINFO?.REGISTEREDADDRESS || "",
      },
      // ✅ merge code + number here
  PRIMARYCONTACT: {
    ...formData.PRIMARYCONTACT,
    PHONENUMBER: formData.PRIMARYCONTACT.PHONENUMBER.map(
      (p) => (p.code || "") + (p.number || "")
    ),
  },
  // ✅ merge Secondary Contact phone numbers
  SECONDARYCONTACT: {
    ...formData.SECONDARYCONTACT,
    PHONENUMBER: (formData.SECONDARYCONTACT.PHONENUMBER || []).map(
      (p) => (p.code || "") + (p.number || "")
    ),
  },
    };

    const response = await fetch("http://127.0.0.1:8000/riverchain/techop/v1.1/saveCompanyProfile", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Save failed: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    console.log("API Response:", result);
    // ✅ Display the company id
if (result.COMPANYID) {
  console.log("New Company ID:", result.COMPANYID);
}
    toast.success("✅ Company saved successfully");

    // redirect after short delay
    setTimeout(() => {
      navigate("/Dashboard");
    }, 1000);
  } catch (error) {
    console.error("Save error:", error);
    toast.error("Failed to save");
  } finally {
    setIsSubmitting(false);
  }
};

// safely get nested value from object using a string path like "SHAREHOLDERS[0].NAME"
const getValueByPath = (obj, path) => {
  return path
    .replace(/\[(\w+)\]/g, ".$1") // convert [0] to .0
    .split(".")
    .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
};

// safely set nested value in object immutably
const setValueByPath = (obj, path, value) => {
  const keys = path.replace(/\[(\w+)\]/g, ".$1").split(".");
  const newObj = { ...obj };
  let current = newObj;

  keys.forEach((key, i) => {
    if (i === keys.length - 1) {
      current[key] = value;
    } else {
      current[key] = Array.isArray(current[key])
        ? [...current[key]]
        : { ...current[key] };
      current = current[key];
    }
  });

  return newObj;
};


  const renderInput = (label, path, options = {}) => {
  const rawValue = getValueByPath(formData, path);

  // convert decimals to percentages if needed
  let displayValue = rawValue ?? "";
  if (options.type === "percentage" ) {
    displayValue = rawValue ? rawValue * 100 : "";
  }

  return (
    <tr>
      <td style={{ width: "50%" }}>{label}</td>
      <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
        <input
          type={
            options.type === "percentage"
              ? "number"
              : options.type === "number"
              ? "number"
              : options.type === "date"         
              ? "date"
              : "text"
          }
          className="form-control"
          value={
            options.type === "date" && displayValue
              ? displayValue.split("T")[0]      
              : displayValue
          }
          onChange={(e) => {
            let value = e.target.value;
            if (options.type === "percentage") {
              value = value ? Number(value) / 100 : 0; // store as decimal
            }else if (options.type === "number") {  
              value = value ? Number(value) : null; 
            }else if (options.type === "date") {   
              value = value ? new Date(value).toISOString() : null;
            }
            setFormData((prev) => setValueByPath(prev, path, value));
          }}
        />
      </td>
    </tr>
  );
};


  return (
    <div className="app-container">
      <Toaster />
      <div className="container-fluid">
        <div className="row">
          <Navbar />

          <div className="col-md-10" style={{ marginTop: "30px" }}>
            <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
              Back to Company Log
            </NavLink>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ marginTop: "10px" }}>Add New Company</h3>
            </div>

            {/* Scorecard Details */}
            <p>
              <b>Scorecard Details</b>
            </p>
            <table className="table table-bordered">
              {renderInput("Scoring Performed by", "ReviewByData.SCORINGPERFORMEDBY")}
              {renderInput("Date", "ReviewByData.DATE", { type: "date" })}
              <tr>
                <td>Reviewed by</td>
                <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
                  <select
                    className="form-control"
                    value={formData?.ReviewByData?.REVIEWEDBY || ""}
                    onChange={(e) => handleChange("ReviewByData.REVIEWEDBY", e.target.value)}
                  >
                    <option value="">-- Select Reviewer --</option>
                    {reviewedby.map((name, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
              {renderInput("Date Reviewed", "ReviewByData.DATE_REVIEW", { type: "date" })}
            </table>

            {/* Company Information */}
            <p>
                <b>Company Information</b>
              </p>
              <table className="table table-bordered">
                {renderInput("Company Name (English)", "COMPANYINFO.COMPANYNAME_ENGLISH", "text", false, true)}
                {renderInput("Company Name (Chinese)", "COMPANYINFO.COMPANYNAME_CHINESE", "text", false, true)}

                {/* Place of Incorporation */}
                <tr>
                  <td style={{ width: "50%" }}>Place of Incorporation</td>
                  <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
                    <select
                      className="form-control"
                      value={formData?.COMPANYINFO?.PLACEOFINCORPORATION || ""}
                      onChange={(e) =>
                        handleChange("COMPANYINFO.PLACEOFINCORPORATION", e.target.value)
                      }
                    >
                      {countries.map((country) => (
                        <option key={country} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>

                {/* Conditional Fields */}
                {formData.COMPANYINFO.PLACEOFINCORPORATION === "Hong Kong" && (
                  <>
                    {renderInput("Business Registration Number", "COMPANYINFO.BUSINESSREGISTRATIONNUMBER")}
                  </>
                )}

                {formData.COMPANYINFO.PLACEOFINCORPORATION === "Singapore" && (
                  <>
                    {renderInput("UEN", "COMPANYINFO.UEN")}
                
                  </>
                )}

                    {renderInput("Registered Address", "COMPANYINFO.REGISTEREDADDRESS")}
                    {renderInput("Year Founded", "COMPANYINFO.YEARFOUNDED", { type: "date" })}
                    {renderInput("Industry", "COMPANYINFO.INDUSTRY")}

                    {renderInput("Nature of Business", "NATUREOFBUSINESS")}
                    {renderInput("Company Type", "COMPANYTYPE")}
                    
                    <tr>
  <td style={{ width: "50%" }}>Category</td>
  <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
    <select
      className="form-control"
      value={formData.INDUSTRY?.CATEGORY || ""}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          INDUSTRY: {
            ...prev.INDUSTRY,
            CATEGORY: e.target.value,
          },
        }))
      }
    >
      <option value="">-- Select category --</option>
      <option value="Subcontractor">Subcontractor</option>
      <option value="Main Contractor">Main Contractor</option>
      <option value="Supplier">Supplier</option>
      <option value="Other">Other</option>
    </select>
  </td>
</tr>

                    {renderInput("Subcategory", "INDUSTRY.SUBCATEGORY")}
                    
                          </table>


                        {/* Shareholder Capital */}
                        <p>
                          <b>Shareholder Capital</b>
                        </p>
                        <table className="table table-bordered">
                          {renderInput("Shareholder capital value (HKD)", "OWNERSHIPSTRUCTURE.SHAREHOLDERCAPITALVALUE_HKD", { type: "number" })}
                          {renderInput("Period", "OWNERSHIPSTRUCTURE.PERIOD", { type: "date" })}
                        </table>

                        {/* Ownership */}
                        <p>
                          <b>Ownership</b>
                        </p>
                        <table className="table table-bordered">
  {renderInput("Shareholder 1", "SHAREHOLDERS[0].NAME")}
  {renderInput("Shareholder 1 ownership %", "SHAREHOLDERS[0].OWNERSHIPPERCENTAGE", { type: "percentage" })}

  {renderInput("Shareholder 2", "SHAREHOLDERS[1].NAME")}
  {renderInput("Shareholder 2 ownership %", "SHAREHOLDERS[1].OWNERSHIPPERCENTAGE", { type: "percentage" })}

  {renderInput("Shareholder 3", "SHAREHOLDERS[2].NAME")}
  {renderInput("Shareholder 3 ownership %", "SHAREHOLDERS[2].OWNERSHIPPERCENTAGE", { type: "percentage" })}

  {renderInput("Director 1", "DIRECTORS[0].NAME")}
  {renderInput("Director 2", "DIRECTORS[1].NAME")}
  {renderInput("Director 3", "DIRECTORS[2].NAME")}
</table>



                        {/* Contact Details */}
                        <p><b>Contact Details</b></p>
<table className="table table-bordered">
  {/* Primary Contact */}
  {renderInput("Primary Contact Name", "PRIMARYCONTACT.NAME")}

  {/* Phone 1 */}
  <tr>
    <td style={{ width: "50%" }}>Primary Contact phone number 1</td>
    <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
      <div className="input-group">
        <span className="input-group-text">
          {formData.PRIMARYCONTACT.PHONENUMBER[0]?.code ||
            countryPhoneCodes[formData.COMPANYINFO.PLACEOFINCORPORATION] ||
            ""}
        </span>
        <input
          type="text"
          className="form-control"
          value={formData.PRIMARYCONTACT.PHONENUMBER[0]?.number || ""}
          pattern="\d{8}"
          minLength={8}
          maxLength={8}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d{0,8}$/.test(value)) {
              const updatedNumbers = [...formData.PRIMARYCONTACT.PHONENUMBER];
              updatedNumbers[0] = {
                code: countryPhoneCodes[formData.COMPANYINFO.PLACEOFINCORPORATION] || "",
                number: value,
              };
              handleChange("PRIMARYCONTACT.PHONENUMBER", updatedNumbers);
            }
          }}
          onBlur={(e) => {
            if (!/^\d{8}$/.test(e.target.value)) {
              alert("Phone number must be exactly 8 digits");
            }
          }}
        />
      </div>
    </td>
  </tr>

  {/* Phone 2 */}
  <tr>
    <td style={{ width: "50%" }}>Primary Contact phone number 2</td>
    <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
      <div className="input-group">
        <span className="input-group-text">
          {formData.PRIMARYCONTACT.PHONENUMBER[1]?.code ||
            countryPhoneCodes[formData.COMPANYINFO.PLACEOFINCORPORATION] ||
            ""}
        </span>
        <input
          type="text"
          className="form-control"
          value={formData.PRIMARYCONTACT.PHONENUMBER[1]?.number || ""}
          pattern="\d{8}"
          minLength={8}
          maxLength={8}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d{0,8}$/.test(value)) {
              const updatedNumbers = [...formData.PRIMARYCONTACT.PHONENUMBER];
              updatedNumbers[1] = {
                code: countryPhoneCodes[formData.COMPANYINFO.PLACEOFINCORPORATION] || "",
                number: value,
              };
              handleChange("PRIMARYCONTACT.PHONENUMBER", updatedNumbers);
            }
          }}
          onBlur={(e) => {
            if (!/^\d{8}$/.test(e.target.value)) {
              alert("Phone number must be exactly 8 digits");
            }
          }}
        />
      </div>
    </td>
  </tr>

  {renderInput("Primary Contact email address", "PRIMARYCONTACT.CONTACTEMAILADDRESS")}
  {renderInput("Riverchain Relationship Manager", "PRIMARYCONTACT.RIVERCHAINRELATIONSHIPMANAGER")}

  {/* Secondary Contact Heading */}
  <tr>
    <td colSpan="2" style={{ fontWeight: "bold", backgroundColor: "#eee" }}>
      Secondary Contact
    </td>
  </tr>

  {/* Secondary Contact Name */}
  {renderInput("Secondary Contact Name", "SECONDARYCONTACT.NAME")}

  {/* Secondary Phone 1 */}
  <tr>
    <td style={{ width: "50%" }}>Secondary Contact phone number 1</td>
    <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
      <div className="input-group">
        <span className="input-group-text">
          {formData.SECONDARYCONTACT.PHONENUMBER?.[0]?.code ||
            countryPhoneCodes[formData.COMPANYINFO.PLACEOFINCORPORATION] ||
            ""}
        </span>
        <input
          type="text"
          className="form-control"
          value={formData.SECONDARYCONTACT.PHONENUMBER?.[0]?.number || ""}
          pattern="\d{8}"
          minLength={8}
          maxLength={8}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d{0,8}$/.test(value)) {
              const updatedNumbers = [...(formData.SECONDARYCONTACT.PHONENUMBER || [{}, {}])];
              updatedNumbers[0] = {
                code: countryPhoneCodes[formData.COMPANYINFO.PLACEOFINCORPORATION] || "",
                number: value,
              };
              handleChange("SECONDARYCONTACT.PHONENUMBER", updatedNumbers);
            }
          }}
          onBlur={(e) => {
            if (!/^\d{8}$/.test(e.target.value)) {
              alert("Phone number must be exactly 8 digits");
            }
          }}
        />
      </div>
    </td>
  </tr>

  {/* Secondary Phone 2 */}
  <tr>
    <td style={{ width: "50%" }}>Secondary Contact phone number 2</td>
    <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
      <div className="input-group">
        <span className="input-group-text">
          {formData.SECONDARYCONTACT.PHONENUMBER?.[1]?.code ||
            countryPhoneCodes[formData.COMPANYINFO.PLACEOFINCORPORATION] ||
            ""}
        </span>
        <input
          type="text"
          className="form-control"
          value={formData.SECONDARYCONTACT.PHONENUMBER?.[1]?.number || ""}
          pattern="\d{8}"
          minLength={8}
          maxLength={8}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d{0,8}$/.test(value)) {
              const updatedNumbers = [...(formData.SECONDARYCONTACT.PHONENUMBER || [{}, {}])];
              updatedNumbers[1] = {
                code: countryPhoneCodes[formData.COMPANYINFO.PLACEOFINCORPORATION] || "",
                number: value,
              };
              handleChange("SECONDARYCONTACT.PHONENUMBER", updatedNumbers);
            }
          }}
          onBlur={(e) => {
            if (!/^\d{8}$/.test(e.target.value)) {
              alert("Phone number must be exactly 8 digits");
            }
          }}
        />
      </div>
    </td>
  </tr>

  {renderInput("Secondary Contact email address", "SECONDARYCONTACT.CONTACTEMAILADDRESS")}
</table>



            {/* Bank Account */}
            <p>
              <b>Bank Account Details</b>
            </p>
            <table className="table table-bordered">
              {renderInput("Beneficiary Name", "PRIMARYACCOUNT.beneficiaryName")}
              {renderInput("Bank Account Number", "PRIMARYACCOUNT.bankAccountNumber")}
               <tr>
          <td style={{ width: "50%" }}>Bank Name</td>
          <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
  <select
    className="form-control"
    value={formData.PRIMARYACCOUNT.bankName}
    onChange={(e) => {
      const selectedBank = e.target.value;
      const details = banks[selectedBank] || {};
      setFormData((prev) => ({
        ...prev,
        PRIMARYACCOUNT: {
          ...prev.PRIMARYACCOUNT,
          bankName: selectedBank,
          bankCode: details.bankCode || "",
          swiftCode: details.swiftCode || "",
        },
      }));
    }}
  >
    <option value="">-- Select Bank --</option>
    {Object.keys(banks)
      .sort((a, b) => a.localeCompare(b)) // 👈 sort alphabetically
      .map((bank) => (
        <option key={bank} value={bank}>
          {bank}
        </option>
      ))}
  </select>
</td>
        </tr>

              {renderInput("Bank Code", "PRIMARYACCOUNT.bankCode", "text", true)}
              {renderInput("SWIFT Code", "PRIMARYACCOUNT.swiftCode", "text", true)}
              <tr>
  <td style={{ width: "50%" }}>Confirmation</td>
  <td style={{ backgroundColor: "#fdf3d0", width: "50%" }}>
    <select
      className="form-control"
      value={formData.PRIMARYACCOUNT.Confirmation}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          PRIMARYACCOUNT: {
            ...prev.PRIMARYACCOUNT,
            Confirmation: e.target.value,
          },
        }))
      }
    >
      <option value="">-- Select Confirmation --</option>
      <option value="Confirmed">Confirmed</option>
      <option value="Not Confirmed">Not Confirmed</option>
    </select>
  </td>
</tr>

              {renderInput("Date of Seller Payment Account Instruction", "PRIMARYACCOUNT.accountInstructionDate", { type: "date" })}
            </table>
            <div className="d-flex justify-content-center mb-3">
              <button
                className="btn btn-primary btn-lg"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
